import React from "react";
const NonMemberCallToActionPanel: React.FC<{}> = () => {
    return (
        <div className="cih-bg-purple cih-hide-print">
            <div className="cih-cta">
                    <p>Become a member and join the CIH community</p>
                <button className="cih-btn-send arrowbutton __dark" onClick={() => { window.location.href = "https://www.cih.org/about-membership" }}>
                        <span className="buttontext">Join today</span>
                        <span className="buttonicon">
                            <span className="buttonicon-topline"></span>
                            <span className="buttonicon-middleline"></span>
                            <span className="buttonicon-bottomline"></span>
                        </span>
                    </button>
            </div>
        </div>
    );
}

export default NonMemberCallToActionPanel;

